import { GraphApiMethod, GraphApiResponse } from '@/api/core';
import { HandleErrorInput, handleError, queryInput } from '@/utils/custom';
import { UpdateProviderLocationMappingInput, UpdateProviderLocationMappingValuesInput } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { UpdateProviderLocationMappingBulkDocument } from '@/api/queries';
import graphApi from '@/api';

export type ProviderLocationMappingUpdate = Partial<UpdateProviderLocationMappingValuesInput> & { id: string };
// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Update Client Mapping' } });

// Service Function Signature
type ServiceMethodPayload = ProviderLocationMappingUpdate[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<GraphApiResponse>;
}

// UpdateProviderLocationMappingBulk Service
export const { updateProviderLocationMappingBulk, useUpdateProviderLocationMappingBulk } = ((): {
  updateProviderLocationMappingBulk: ServiceMethod;
  useUpdateProviderLocationMappingBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(UpdateProviderLocationMappingBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof UpdateProviderLocationMappingBulkDocument>): ServiceMethod =>
      async (payload: ServiceMethodPayload): Promise<GraphApiResponse> => {
        const updates: UpdateProviderLocationMappingInput[] = payload.map(
          ({ id, ...update }): UpdateProviderLocationMappingInput => ({
            query: [{ id: queryInput(id) }],
            value: { ...update },
          })
        );
        const res = await fn({ input: { updates } });
        return res;
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    updateProviderLocationMappingBulk: mutate,
    useUpdateProviderLocationMappingBulk: useService,
  };
})();
